<template>
  <v-container v-if="bookingContext">

    <v-progress-linear :active="isLoading" :indeterminate="isLoading" absolute
                       color="deep-purple accent-4"></v-progress-linear>
    <BookingHeader :bookingContext="bookingContext"/>

    <v-row>

      <v-col cols="12" sm="12">
        <v-form @submit.prevent="confirmeIntentPayment" :disabled="isLoading">
          <!-- placeholder for Stripe Elements -->
          <div id="card-element"></div>


          <div style="padding: 0.65rem 0.6rem;">
            <v-checkbox v-model="validateConditions" required>
              <template v-slot:label>
                <div>
                  {{$t('booking.payment.cgu_check_label_1')}} ‘{{$t('booking.payment.book_button_label')}}’,
                  {{$t('booking.payment.cgu_check_label_2')}}
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <a target="_blank" :href="cguUrl" @click.stop v-on="on">{{$t('booking.payment.cgu_check_label_3')}}</a>
                    </template>
                    Opens in new window
                  </v-tooltip>
                  {{$t('booking.payment.cgu_check_label_4')}}
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <a target="_blank" :href="rentalUrl" @click.stop v-on="on">{{$t('booking.payment.cgu_check_label_5')}}</a>
                    </template>
                    Opens in new window
                  </v-tooltip>
                </div>
              </template>
            </v-checkbox>
          </div>

          <AppAlert :alert="error"/>

          <v-btn color="primary" type="submit" depressed solo :loading="isLoading" :disabled="!cardReady">
            <v-icon class="mr-2">mdi-book</v-icon>
            {{$t('booking.payment.book_button_label')}}
            <span style="font-weight: 300;font-size: 1rem;padding-left: 0.8rem"> ({{ bookingContext.totalTTC | currency}})</span>
          </v-btn>

        </v-form>
      </v-col>


    </v-row>
  </v-container>

</template>

<script>

  import { BookingHeader } from '../components';
  import { BookingSteps } from "../models";
  import { BookingService } from "../services";
  import { LocationsApi } from "@/shared/services";
  import { AppConfigApi } from '../../../shared/services/api/app-config'
  import Vue from 'vue'
  import moment from 'moment'
  import { PayStripeApi } from '../../../shared/services/api'
  import { mapGetters } from 'vuex'

  export default {
    name: 'BookingPaymentStripeStep',
    components: {
      BookingHeader
    },
    props: {
      bookingContext: null
    },
    data () {
      return {
        cguUrl: "/p/api/v1/loc/cgu/driver",
        rentalUrl: "/p/api/v1/loc/cgu/rental",
        validateConditions: true,
        isLoading: true,
        error: null,
        stripe: null,
        elements: null,
        cardElement: null,
        cardReady: false
      };
    },
    methods: {
      confirmeIntentPayment () {

        var _this = this;
        console.log("confirmeIntentPayment", _this.elements, this.cardElement)
        _this.isLoading = true;
        this.stripe.confirmPayment({
          elements: _this.elements,
          redirect: 'if_required'
        }).then(result => {
          console.debug("confirmSetup", result);
          this.$emit('nextStep', this.bookingContext);
          if (result.error) {
          }
        });

      },
      includeStripe (URL, callback) {
        let documentTag = document, tag = 'script',
          object = documentTag.createElement(tag),
          scriptTag = documentTag.getElementsByTagName(tag)[0];
        object.src = '//' + URL;
        if (callback) {
          object.addEventListener('load', function (e) {
            callback(null, e);
          }, false);
        }
        scriptTag.parentNode.insertBefore(object, scriptTag);
      },
      configureStripe (clientSecret) {
        var locale = store.getters['main/locale'];
        PayStripeApi.getStripeInfo()
          .then(data => {

            this.stripe = Stripe(data.publishableKey);

            var elementsOptions = {
              /*  appearance: {
                  theme: 'flat'
                },*/
              locale: locale,
              clientSecret: clientSecret
            }
            this.elements = this.stripe.elements(elementsOptions);
            this.cardElement = this.elements.create('payment');
            this.cardElement.mount('#card-element');

            let _this = this;
            this.cardElement.on('ready', function () {
              _this.isLoading = false;
              _this.cardElement.on('change', function (event) {
                if (event.complete) {
                  _this.cardReady = true;
                } else {
                  _this.cardReady = false;
                }
              });

            });

          })
          .catch(error => console.error("Stripe error : ", error))
          .finally(() => {
          })

      },
    },
    computed: {
      ...mapGetters({ currency: 'main/currency' })
    },
    mounted () {
      this.includeStripe('js.stripe.com/v3/', function () {
        var obj = { locationId: this.bookingContext.number, currency: this.currency.code };
        console.log("Intent", obj);
        PayStripeApi.getIntent(obj)
          .then(data => {
            console.debug("GetIntent : ", data);
            this.configureStripe(data.client_secret);
          })
          .catch(error => {
            console.error("GetIntent : ", error);
          })

      }.bind(this));

    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @media (min-width: 960px) {
    .container {
      width: 66rem;
    }

    .padding-like-field {
      padding: 5.12rem 0 0 0;
    }

    .box {
      margin: 1rem 2rem !important;
    }

    .padding-comment {
      padding: 1rem 10rem !important;
    }
  }

  .padding-top {
    padding-top: 4rem;
  }

  .padding-comment {
    padding: 0.8rem;
  }

  .box {
    margin: 0.3rem;
  }


</style>
